import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteCandidateComponent } from './components/autocomplete-candidate/autocomplete-candidate.component';
import { AutocompleteDiagnosticComponent } from './components/autocomplete-diagnostic/autocomplete-diagnostic.component';
import { NgaModule } from '../../theme/nga.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Angular2FontawesomeModule } from 'angular2-fontawesome/angular2-fontawesome';
import { DndModule } from 'ng2-dnd';

import {
  AutoCompleteModule,
} from 'primeng/primeng';


import { NgxChartsModule } from '@swimlane/ngx-charts';

import { Angular2PromiseButtonModule } from 'angular2-promise-buttons/dist';


import { HttpModule, Http, RequestOptions } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslatePoHttpLoader } from '@biesbjerg/ngx-translate-po-http-loader';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ApplicationPipesModuleModule } from '../application-pipes-module/application-pipes-module.module';
import { AutocompleteCandidateDisabilityComponent } from './components/autocomplete-candidate-disability/autocomplete-candidate-disability.component';
import { AutocompleteCompanyComponent } from './components/autocomplete-company/autocomplete-company.component';

export function createTranslateLoader(http: Http) {
  return new TranslatePoHttpLoader(http, '/assets/i18n/', '.po');
}

@NgModule({
  exports:[
    AutocompleteCandidateComponent,
    AutocompleteDiagnosticComponent,
    AutocompleteCandidateDisabilityComponent,
    AutocompleteCompanyComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AutoCompleteModule,
    Angular2PromiseButtonModule.forRoot({
        spinnerTpl: '<i class="fa fa-circle-o-notch fa-spin fa-fw btn-load"></i>',
        disableBtn: true,
        btnLoadingClass: 'is-loading',
        handleCurrentBtnOnly: false,
    }),
    NgaModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [Http]
      }
    }),
    
    InfiniteScrollModule,
    NgxChartsModule,
    Angular2FontawesomeModule,
    DndModule,
    ApplicationPipesModuleModule
    
  ],
  declarations: [
    AutocompleteCandidateComponent,
    AutocompleteDiagnosticComponent,
    AutocompleteCandidateDisabilityComponent,
    AutocompleteCompanyComponent
  ]
})
export class CustomAutocompleteModule { }



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/custom-autocomplete/custom-autocomplete.module.ts